module.exports = __webpack_public_path__ + "img/school.75da58a1.svg";